var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHundeskovHundepark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#427c7f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.12,11.017a8.192,8.192,0,0,0-.4-.772l.221-1.127a.744.744,0,0,0,.466-.946c-.028-.218-.266-.19-.266-.19l-1.215.243C5.52,7.947,5.55,8.3,5.55,8.3l.222.868s-1.236.269-1.757.37a1.1,1.1,0,0,1-.99-.225c-.13-.13-.2-.065-.2-.065s-.107.023.011.213A3.04,3.04,0,0,0,3.4,9.97a.93.93,0,0,0-.189.359l-.557.192-.433.492a.189.189,0,0,0,0,.3.186.186,0,0,0,.29-.006l.35-.379.581-.026-.314.32v.723a.226.226,0,0,0,.213.208A.193.193,0,0,0,3.564,12v-.521a4.5,4.5,0,0,1,.682-.32.886.886,0,0,0,.515-.445l1.095.226.031.438s-.468.362-.545.456-.089.149,0,.261a.174.174,0,0,0,.2.071s.539-.308.64-.361a.306.306,0,0,0,.136-.16l.154-.611.243.208s.285.527.3.575a.293.293,0,0,0,.3.142c.183-.012.124-.207.124-.207S7.209,11.254,7.12,11.017Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.412,9.193s-1.568-2.719-1.586-2.748a.055.055,0,0,1,.045-.086h.618a.2.2,0,0,0,.174-.3L10.832,2.886a.2.2,0,0,0-.348,0L8.653,6.057a.2.2,0,0,0,.174.3h.619a.056.056,0,0,1,.048.078L7.9,9.193a.2.2,0,0,0,.174.3h2.007a.194.194,0,0,1,.194.194v2.1a.38.38,0,0,0,.76,0V9.7a.2.2,0,0,1,.2-.2h2A.2.2,0,0,0,13.412,9.193Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHundeskovHundepark);
export default __webpack_public_path__ + "static/media/HUNDESKOV-HUNDEPARK.95ccf78bc93e2692e44b51d42eb48c11.svg";
export { ForwardRef as ReactComponent };